import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Being young and naive",
  "description": "",
  "published": "2012-12-04T00:00:00.000Z",
  "redirect_from": ["/blog/being-young-and-naive/swizec/5636"],
  "categories": "Philosophy, Slovenia, Uncategorized, Young, Youth",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/12/Screen-Shot-2012-12-04-at-12.47.42-PM.png",
        "alt": "InstaGotof",
        "title": "InstaGotof"
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.05,14.5&spn=10.0,10.0&q=46.05,14.5%20(Slovenia)&t=h",
        "title": "Slovenia"
      }}>{`Slovenia`}</a>{` is in turmoil right now. Protests against the government are happening almost daily, some are turning into riots. This happens in countries with a lot of unemployed and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Underemployment",
        "title": "Underemployment"
      }}>{`underemployed`}</a>{` young people. Especially if you also add a lot of established industries falling apart and everything that brings with it.`}</p>
    <p>{`Have to congratulate the police on their bang on job, though! Just 100 meters from a full out war you would never guess something odd was going on.`}</p>
    <p>{`Last week I published my opinion on the matter (`}<a parentName="p" {...{
        "href": "http://www.had.si/blog/2012/12/01/vsi-pizdakajo-nihce-ne-bi-delal/"
      }}>{`link in sloveninan`}</a>{`), perhaps foolishly, I seemingly went against all the protestors. Although it's difficult to say because they are merely `}<em parentName="p">{`against`}</em>{`, without much notion as to what they are `}<em parentName="p">{`for`}</em>{`.`}</p>
    <h2 {...{
      "id": "young-and-naive"
    }}>{`Young and naive`}</h2>
    <p>{`There was a lot of backlash. Eventually had to turn off twitter so I could get some work done, didn't dare read the 70+ comments left on the post itself.`}</p>
    <p>{`People my age and younger mostly quipped that I am a neoliberalist scumbag, whatever that is ... the post itself was really more libertarian in nature. Promoting the idea of self-sufficiency rather than relying on external factors for your happiness and success in life.`}</p>
    <p>{`Those older than me predominantly agreed that I am simply being young and naive.`}</p>
    <p><em parentName="p">{`"Oh, kiddo. You have so much to learn in life still. Why do you spout nonsense when my sage wisdom has taught me that you are just young and naive? You live in a bubble, boy. A sheltered existence!"`}</em></p>
    <p>{`_`}{`_`}{`I know I should just ignore ad hominems, but this one hits very close to home.`}</p>
    <p>{`It's the sort of logic I've had to deal with all my life. People simply dismissing what I have to say because I am younger. When they agree - `}<em parentName="p">{`"Oh my, what a wise youngster!"`}</em>{` - when they disagree - `}<em parentName="p">{`"Oh the follies of naive youth; he'll learn"`}</em></p>
    <p>{`Can there be anything more annoying?`}</p>
    <p>{`The treatment began when I was about 14. Of `}<em parentName="p">{`course`}</em>{` his opinion of the world is completely invalid! Look at the pubescent youngster, thinks he's absorbed the wisdom of the world. HA!`}</p>
    <p>{`Back then it was nihilism. I couldn't come to terms with the idea nothing I do ultimately matters in the grand scheme of things. It was too much freedom to bear. Discussing with adults didn't help much, their feedback amounted to `}<em parentName="p">{`"Oh, you're young. You'll grow out of it eventually."`}</em></p>
    <p>{`I didn't grow out of it. I simply learned to harness the immense freedom and power stemming from the ability to do anything.`}</p>
    <p>{`Similarly I've always believed I can `}<em parentName="p">{`achieve`}</em>{` anything if I just try. Once I really set my mind on something, I will get there eventually. Probably not on the first try though.`}</p>
    <p>{`Mentioning this to adults ... `}<em parentName="p">{`"Oh you poor soul. You've lived a sheltered life under your mommy, don't you know? Real life doesn't work that way"`}</em></p>
    <p>{`Well, I don't know what crawled up those adults' behinds, but so far I have reached and surprassed all goalposts I have ever set for myself, with the exceptions of those where found a better goalpost.`}</p>
    <p>{`I had to stop setting goalposts ...`}</p>
    <p>{`Being excited about success is much better than the emptiness that comes from reaching a goalpost and looking into the void beyond.`}</p>
    <p>{`So yes, I do live in a bubble. My life `}<em parentName="p">{`is`}</em>{` going surprisingly marvelously. I `}<em parentName="p">{`do`}</em>{` enjoy every single day like it was the best thing since sliced bread.`}</p>
    <p>{`But I built this bubble myself. I come from a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Single_parent",
        "title": "Single parent"
      }}>{`single-parent`}</a>{` home, my mum is a disgruntled `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Civil_service",
        "title": "Civil service"
      }}>{`government employee`}</a>{` with 20+ years of service. At times she's had to work several jobs so we could make it through the month. Nothing was handed to me on a silver platter - I got plenty of things on a tin platter though; I'm grateful for those.`}</p>
    <p>{`I live in a bubble because all my life I have been young and naive. Naive enough to believe in myself, foolish enough to never ask permission.`}</p>
    <p>{`My one dream in life is to stay this way until the day I die.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ornamentalelements.com/2012/12/03/always-stay-naive/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/129649866_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://ornamentalelements.com/2012/12/03/always-stay-naive/"
        }}>{`Always Stay Naive`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://tomaplomb.blogspot.com/2012/10/goalposts-and-gray-areas.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/118276132_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://tomaplomb.blogspot.com/2012/10/goalposts-and-gray-areas.html"
        }}>{`Goalposts and Gray Areas`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://bardhasflown.wordpress.com/2012/11/20/the-next-real/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_78_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://bardhasflown.wordpress.com/2012/11/20/the-next-real/"
        }}>{`Literary rebels: Quaint, backward, naive, anachronistic`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/13701374/how-to-improve-this-common-construct"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_45_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/13701374/how-to-improve-this-common-construct"
        }}>{`How to improve this common construct?`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=82c25b76-edc1-4dae-9c53-a29763261266",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      